import React, { Component } from "react";
import { compose } from "recompose";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
// import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import SubAgentTree from "./SubAgentTree";
const styles = (theme) => ({});

class SubAgentTreeDialog extends Component {
  selectSubAgentClick = () => {
    const { selectSubAgent, IdAgent } = this.props;
    selectSubAgent(IdAgent, "");
  };
  selectSubAgent = (sugAgent) => {
    const { selectSubAgent, handleCloseClonedSubAgent } = this.props;
    selectSubAgent(sugAgent.IdAgent, sugAgent.Agent);
    handleCloseClonedSubAgent();
  };
  render() {
    const {
      openClonedSubAgent,
      handleCloseClonedSubAgent,
      selectedSubAgent,
      SubAgents,
    } = this.props;
    return (
      <Dialog
        open={openClonedSubAgent}
        onClose={handleCloseClonedSubAgent}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Select Sub Agent</DialogTitle>
        <DialogContent>
          {/*<Button onClick={this.selectSubAgentClick}>Select Me</Button>*/}
          <List component="nav">
            <SubAgentTree
              {...{
                selectedSubAgent,
                SubAgents,
                selectSubAgent: this.selectSubAgent,
              }}
            />
          </List>
        </DialogContent>
      </Dialog>
    );
  }
}

SubAgentTreeDialog.propTypes = {
  theme: PropTypes.object.isRequired,
  IdAgent: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  SubAgents: PropTypes.array.isRequired,
  selectSubAgent: PropTypes.func.isRequired,
  selectedSubAgent: PropTypes.string.isRequired,
  openClonedSubAgent: PropTypes.bool.isRequired,
  handleCloseClonedSubAgent: PropTypes.func.isRequired,
};

export default compose(
  withStyles(styles, {
    name: "SubAgentTreeDialog",
    withTheme: true,
  }),
)(SubAgentTreeDialog);
